// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import StyledButton from "./Button.styled";
import { ThemeProvider } from "styled-components";
import ThemeProviderStyled from "../../theme/ThemeProvider.styled";

const Button = ({ link, type, text, disabled, onClick, className }) => {
    return (
        <ThemeProvider theme={ThemeProviderStyled}>    
            <StyledButton className={className} link={link} type={type} disabled={disabled} onClick={onClick}>
                <span>{text}</span>
            </StyledButton>
        </ThemeProvider>
    );
};

export default Button;

// props validation
Button.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    link: PropTypes.bool,
    disabled: PropTypes.bool
};
